export default "__VITE_ASSET__DJb8KmS3__"